(() => {
  const root = document.querySelector('.ww-about');
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const textTargets = [...root.querySelectorAll('.ww-about__copy > p')];
  const originals = new Map(textTargets.map((element) => [element, {
    text: element.innerText.trim(),
    fixedLines: element.matches('.ww-about__invitation')
      ? [...element.children].map((line) => line.innerText.trim()).filter(Boolean)
      : null
  }]));

  const appendLines = (element, lines) => {
    lines.forEach((text, index) => {
      const line = document.createElement('span');
      line.className = 'ww-about__reveal-line';
      line.setAttribute('aria-hidden', 'true');
      line.style.setProperty('--ww-line-index', index);
      const inner = document.createElement('span');
      inner.className = 'ww-about__reveal-line__inner';
      inner.textContent = text;
      line.append(inner);
      element.append(line);
    });
  };

  const splitIntoRenderedLines = (element) => {
    const original = originals.get(element);
    if (!original?.text) return;

    const wasVisible = element.classList.contains('is-visible');
    element.classList.add('ww-about__reveal');
    element.replaceChildren();

    if (original.fixedLines) {
      const accessibleText = document.createElement('span');
      accessibleText.className = 'ww-visually-hidden';
      accessibleText.textContent = original.text.replace(/\s+/g, ' ').trim();
      element.append(accessibleText);
      appendLines(element, original.fixedLines);
      if (wasVisible) element.classList.add('is-visible');
      return;
    }

    const measuredWords = [];
    original.text.split('\n').forEach((segment, segmentIndex) => {
      if (segmentIndex) element.append(document.createElement('br'));
      segment.trim().split(/\s+/).filter(Boolean).forEach((word) => {
        const measure = document.createElement('span');
        measure.className = 'ww-about__measure-word';
        measure.textContent = `${word} `;
        element.append(measure);
        measuredWords.push(measure);
      });
    });

    const groups = [];
    measuredWords.forEach((word) => {
      const top = Math.round(word.offsetTop);
      const current = groups.at(-1);
      if (!current || current.top !== top) groups.push({ top, words: [word.textContent.trim()] });
      else current.words.push(word.textContent.trim());
    });

    element.replaceChildren();
    const accessibleText = document.createElement('span');
    accessibleText.className = 'ww-visually-hidden';
    accessibleText.textContent = original.text.replace(/\s+/g, ' ').trim();
    element.append(accessibleText);
    appendLines(element, groups.map((group) => group.words.join(' ')));

    if (wasVisible) element.classList.add('is-visible');
  };

  textTargets.forEach(splitIntoRenderedLines);

  const blockTargets = [
    root.querySelector('.ww-about__title'),
    root.querySelector('.ww-about__squiggle'),
    root.querySelector('.ww-about__signoff')
  ].filter(Boolean);
  blockTargets.forEach((element) => element.classList.add('ww-about__block-reveal'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: .08, rootMargin: '0px 0px -8% 0px' });

  const revealOrObserve = (element) => {
    if (element.getBoundingClientRect().top < window.innerHeight * .92) {
      const rect = element.getBoundingClientRect();
      if (window.scrollY < 120 && rect.bottom > 0) {
        element.style.setProperty('--ww-entry-delay', `${Math.min(initialRevealIndex * 115, 805)}ms`);
        initialRevealIndex += 1;
      }
      element.classList.add('is-visible');
      return;
    }
    observer.observe(element);
  };

  let initialRevealIndex = 0;
  const revealTargets = [...textTargets, ...blockTargets].sort((first, second) => (
    first.compareDocumentPosition(second) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
  ));

  requestAnimationFrame(() => requestAnimationFrame(() => {
    revealTargets.forEach(revealOrObserve);
  }));

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => textTargets.forEach(splitIntoRenderedLines), 180);
  }, { passive: true });
})();
